// extracted by mini-css-extract-plugin
module.exports = {"logo":"Header_logo__1tWlB","header":"Header_header__3_jch","link":"Header_link__r5Qlh","active":"Header_active__3y__G"};